import { Container, Row, Col, Card, Button, Image } from "react-bootstrap";
import HomeCarousel from "../../common/Carousel/Carousel";
import ProductList from "../Product/ProductList";
import Banner from "../../../images/banner.jpg";
import { FaCog, FaPlayCircle } from "react-icons/fa"

const Home = () => {


  return (
    <>
      <HomeCarousel />
      <Container>
        <Row>
          <Col lg={12} md={12} sm={12} xs={12}>
            <h1 className="text-left hover-underline">Products</h1>
          </Col>
        </Row>

      </Container>
      <ProductList />

      <section style={{ background: `url(${Banner}) 0 0 / cover`, padding: "100px 0" }}>
        <Container>
          <Row>
            <Col lg={12}>
              <h1 className="text-center text-white">NEW STYLISH COLLECTION</h1>
              <FaPlayCircle size={40} className="text-center text-white" />
            </Col>
          </Row>
        </Container>
      </section >

    </>
  );
}

export default Home;